// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)

import _ from "lodash";
import Tooltip from "rc-tooltip";
import React, { useEffect, useState } from "react";
import { Handles, Rail, Slider, Ticks, Tracks } from "react-compound-slider";
import type { SliderItem } from "react-compound-slider";
import { MFASlider } from "./MFASlider";

interface TickProps {
	tick: SliderItem;
	text: string;
	onClick: () => void;
}

const Tick: React.FC<TickProps> = ({ tick, text, onClick }) => {
	return (
		<Tooltip
			placement="bottom"
			mouseEnterDelay={0}
			mouseLeaveDelay={0}
			trigger="hover"
			motion={{ motionName: "rc-tooltip-zoom" }}
			overlay={<div>{text}</div>}
		>
			<div
				onClick={onClick}
				style={{
					position: "absolute",
					marginTop: 8,
					cursor: "pointer",
					height: 4,
					width: 2,
					translate: "-50%",
					backgroundColor: "var(--neutral-50)",
					left: `${tick.percent}%`,
				}}
			/>
		</Tooltip>
	);
};

const sliderStyle: React.CSSProperties = {
	position: "relative",
	width: "auto",
	margin: "0 10px",
	height: 20,
	touchAction: "none",
};

type Props<T extends { text: string }> = {
	className: string;
	mappedDates: { [timeValue: number]: T };
	selectedDate: number;
	onChange: (date: number) => void;
};

export const DateTimeSlider = <T extends { text: string }>({
	className,
	mappedDates,
	onChange,
	selectedDate,
}: Props<T>) => {
	const timeValues = _.map(Object.keys(mappedDates), Number);
	const domain: [number, number] = [(_.min(timeValues) ?? 0) - 1, (_.max(timeValues) ?? 0) + 1];
	const [value, setValue] = useState(selectedDate);

	// HACK: Find a better way to do this!
	useEffect(() => {
		// eslint-disable-next-line react-hooks/set-state-in-effect
		setValue(selectedDate);
	}, [value, selectedDate]);

	const handleChange = (value: number) => {
		setValue(value);
		const closest = _.reduce(
			timeValues,
			(acc, curr) => (Math.abs(curr - value) < Math.abs(acc - value) ? curr : acc),
			timeValues[0],
		);
		onChange(closest);
		// setValue(closest);
	};

	// const handleUpdate = (value: number) => {
	// 	setValue(value);
	// };

	return (
		<Slider
			className={`mfaSlider ${className}`}
			domain={domain}
			rootStyle={sliderStyle}
			onChange={(v) => handleChange(v[0])}
			// onUpdate={(v) => handleUpdate(v[0])}
			values={[value]}
		>
			<Rail>{({ getRailProps }) => <MFASlider.SliderRail className="datetime" getRailProps={getRailProps} />}</Rail>
			<Handles>
				{({ handles, getHandleProps }) => (
					<div className="slider-handles">
						{handles.map((handle) => (
							<MFASlider.KeyboardHandle
								key={handle.id}
								handle={handle}
								domain={domain}
								getHandleProps={getHandleProps}
							/>
						))}
					</div>
				)}
			</Handles>
			<Tracks left={false} right={false}>
				{({ tracks, getTrackProps }) => (
					<div className="slider-tracks">
						{tracks.map(({ id, source, target }) => (
							<MFASlider.Track key={id} source={source} target={target} getTrackProps={getTrackProps} />
						))}
					</div>
				)}
			</Tracks>
			<Ticks values={timeValues}>
				{({ ticks }) => (
					<div className="slider-ticks">
						{ticks.map((tick) => (
							<Tick
								key={tick.id}
								tick={tick}
								text={mappedDates[tick.value].text}
								onClick={() => {
									handleChange(tick.value);
								}}
							/>
						))}
					</div>
				)}
			</Ticks>
		</Slider>
	);
};
